export default __webpack_public_path__ + "static/media/GuyAnimation15.8479eee1.svg";